import SearchableObject from "./SearchableObject";
import LangUtils from "../../utils/LangUtils";

export default class MapElementSearchableObject extends SearchableObject {
    constructor(mapElement, language, baseUrl) {
        super();
        this.mapElement = mapElement;
        this.language = language;
        this.baseUrl = baseUrl;
    }

    getId() {
        return this.mapElement.getId();
    }

    getName() {
        return LangUtils.valueForLanguage(this.mapElement.getName(), this.language);
    }

    getType() {
        return this.mapElement.getType();
    }

    isSelectable() {
        return this.getType() != "layer" && (this.mapElement.isInteractive() == true || this.mapElement.isInteractive() == undefined);
    }

    isHideable() {
        return this.mapElement.isHideable();
    }

    get visible() {
        return !this.mapElement.isHidden();
    }

    set visible(visible) {
        this.mapElement.setHidden(!visible);
    }

    getIconUrl(highRes) {
        const iconFileName = this.mapElement.getIconFileName();
        if (iconFileName) {
            const fileName = LangUtils.valueForLanguage(iconFileName, this.language);
            if (!highRes) {
                var newFileName = fileName.replace("@2x", "")
                return this.baseUrl + "/" + newFileName;
            } else {
                newFileName = fileName.replace(".png", "@2x.png");
                newFileName = newFileName.replace(".jpg", "@2x.jpg");
                return this.baseUrl + "/" + newFileName;
            }
        } else if (this.mapElement.getIconUrl()) {
            return LangUtils.valueForLanguage(this.mapElement.getIconUrl(), this.language);
        } else {
            return null;
        }
    }

    getTags() {
        return this.mapElement.getTags();
    }
}